import { css } from "@emotion/react";
import styled from "@emotion/styled";

import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import { useWidth } from "custom-hooks/use-width.hook";
import * as React from "react";
import Button from "@components/Button";
import SliderTransition from "@components/slide-transition";
import Dialog, { DialogProps } from "@mui/material/Dialog";
import YouTube, { YouTubeProps } from "react-youtube";

export default function VideoModal(props: any) {
  const [open, setOpen] = React.useState(false);
  const width = useWidth();
  const opts: YouTubeProps["opts"] = {
    height: "380px",
    width: "100%",
    playerVars: {
      autoplay: 0,
      modestbranding: 1,
      rel: 0,
      showinfo: 0,
      control: 0,
    },
  };
  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const configProp: DialogProps = {
    open: open,
    TransitionComponent: SliderTransition,
    onClose: handleClose,
    fullWidth: true,
    fullScreen: ["xs", "sm"].includes(width),
    maxWidth: "md",
    ...props,
  };

  return (
    <>
      {React.cloneElement(props.children, {
        onClick: handleClickOpen,
        id: "FormJoinRemax",
      })}
      <DialogCustom {...configProp}>
        <DialogHeader {...configProp}></DialogHeader>
        <DialogContent>
          {props.src ? (
            <ModalVideo controls autoPlay playsInline title={props.title}>
              <source src={props.src} type={props.type ?? "video/mp4"} />
            </ModalVideo>
          ) : (
            <YouTube videoId={props.url} opts={opts}></YouTube>
          )}
        </DialogContent>
      </DialogCustom>
    </>
  );
}

const DialogHeader = (props: any) => (
  <DialogTitle css={stylesDialogHeader.root} fontSize={12} align="right">
    <Button
      variant="text"
      colortext={"--color-brand-grey-secondary"}
      onClick={() => props.onClose()}
    >
      Cerrar
    </Button>
  </DialogTitle>
);

const TitleForm = styled.h2`
  color: var(--color-brand-grey-main);
  font-size: 1.2rem;
  margin-bottom: 10px;
`;

const ModalVideo = styled.video`
  background-color: #000;
  border-radius: 12px;
  display: block;
  max-height: 70vh;
  width: 100%;
`;

const DialogCustom = styled(Dialog)(({ theme }) => ({
  "& .MuiDialog-paper": {
    backgroundColor: "#EFEFF1",
    borderRadius: "20px",
  },
}));

const stylesDialogHeader = {
  root: css({
    textAlign: "right",
    fontSize: 13,
    color: "var(--color-brand-grey-main)",
    cursor: "pointer",
  }),
};
